// extracted by mini-css-extract-plugin
export default {"status":"status_status__URO5p","default":"status_default__vsqS0","completed":"status_completed__kSNPY","error":"status_error__VX3yT"};